module.exports = __webpack_public_path__ + "static/canvas-zoom-124a849499419463c70fb2e17c9256f9.jpg";